<template>
  <ai-visibility-sidebar
      :open="open"
      :aria-label="`${question.questionText} question details`"
      close-label="Close question details"
      @close="$emit('close')"
      @after-close="$emit('after-close')"
  >
    <section class="ai-visibility-question-sidebar">
      <div class="ai-visibility-question-sidebar__top">
        <div class="ai-visibility-question-sidebar__title-row">
          <h2>"{{ question.questionText }}"</h2>
        </div>
      </div>

      <question-sidebar-metric-cards :question="question"/>

      <question-mentioned-brands-list
          :asked-count="question.askedCount"
          :brands="question.topBrands"
          :tracked-domain="trackedDomain"
      />

      <question-sources-list
          :citations="question.topCitations"
          :tracked-domain="trackedDomain"
      />

      <question-fan-out-queries-list :queries="question.fanOutQueries"/>

    </section>
  </ai-visibility-sidebar>
</template>

<script>
import AiVisibilitySidebar from '../../../ui/overlays/AiVisibilitySidebar.vue'
import QuestionSidebarMetricCards from './QuestionSidebarMetricCards.vue'
import QuestionMentionedBrandsList from './QuestionMentionedBrandsList.vue'
import QuestionSourcesList from './QuestionSourcesList.vue'
import QuestionFanOutQueriesList from './QuestionFanOutQueriesList.vue'

export default {
  name: 'QuestionDetailsSidebar',
  components: {
    AiVisibilitySidebar,
    QuestionSidebarMetricCards,
    QuestionMentionedBrandsList,
    QuestionSourcesList,
    QuestionFanOutQueriesList,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    question: {
      type: Object,
      required: true,
    },
    trackedDomain: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-question-sidebar {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ai-visibility-question-sidebar__top {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ai-visibility-question-sidebar__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}

.ai-visibility-question-sidebar__title-row h2 {
  color: var(--v-mainColor-base);
  flex: 1 1 auto;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
}

.ai-visibility-question-sidebar__title-row button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid var(--v-mainColor-base);
  border-radius: 999px;
  background: var(--v-cardBg-base);
  color: var(--v-mainColor-base);
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  padding: 8px 14px;
  white-space: nowrap;
}

.ai-visibility-question-sidebar__title-row button:focus {
  outline: 2px solid var(--v-lightYellowColor-base);
  outline-offset: 2px;
}

.ai-visibility-question-sidebar__title-row button {
  flex: 0 0 auto;
  border-color: transparent;
  padding-right: 0;
}

.ai-visibility-question-sidebar__title-row i {
  font-size: 18px;
}

.ai-visibility-question-sidebar__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  color: #2C2C2C;
  font-size: 16px;
  font-weight: 400;
  margin: 0;
}

@media (max-width: 420px) {
  .ai-visibility-question-sidebar__title-row {
    flex-direction: column;
  }

  .ai-visibility-question-sidebar__title-row button {
    padding-left: 0;
  }
}
</style>
